module.exports = __webpack_public_path__ + "static/media/main-june.d686bf2a.png";